export default __webpack_public_path__ + "static/media/USAID_Horiz_Spanish_CMYK_2-Color-01.c5c3b872.png";